import DOMPurify from "dompurify";

// Renders admin/CMS-authored HTML safely (strips scripts, event handlers, etc.)
export default function SafeHtml({ html, className }) {
  const clean = DOMPurify.sanitize(html || "", {
    ADD_ATTR: ["target", "rel"],
    FORBID_TAGS: ["style", "script", "iframe", "form", "input"],
  });
  return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
}
